import { FooterToolbarRow } from "@circle-react/components/QuickPostV3/Composer/FooterToolbarRow";
import { PostFields } from "@circle-react/components/QuickPostV3/Composer/PostFields";
import { useComposerLayout } from "@circle-react/components/QuickPostV3/hooks/useComposerLayout";
import { QuickPostModalBody } from "@circle-react/components/QuickPostV3/QuickPostModalBody";

interface BodyProps {
  shouldShowTipTap: boolean;
}

export const Body = ({ shouldShowTipTap }: BodyProps) => {
  const { shouldInlineTopics } = useComposerLayout();

  return (
    <div className="bg-secondary flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
      <div className="bg-primary flex min-h-0 flex-1 flex-col overflow-hidden rounded-b-lg">
        <QuickPostModalBody customLayout data-testid="quick-post-v3-body">
          <div className="flex min-h-full flex-col">
            <PostFields shouldShowTipTap={shouldShowTipTap} />
          </div>
        </QuickPostModalBody>
        <FooterToolbarRow inline={shouldInlineTopics} />
      </div>
    </div>
  );
};
